const paths = {
  shield: 'M12 2.5 4.5 5.8v5.4c0 4.6 3.2 8.9 7.5 10.3 4.3-1.4 7.5-5.7 7.5-10.3V5.8L12 2.5Z',
  bolt: 'M13 2 4.5 13.5H11L10.5 22 19.5 10H13l0-8Z',
  lock: 'M6.5 10V7.5a5.5 5.5 0 0 1 11 0V10M5 10h14v11H5z',
  headset: 'M4 13v-1a8 8 0 0 1 16 0v1M4 13v3a2 2 0 0 0 2 2h1v-6H6a2 2 0 0 0-2 1Zm16 0v3a2 2 0 0 1-2 2h-1v-6h1a2 2 0 0 1 2 1Zm-3 6v.5a2.5 2.5 0 0 1-2.5 2.5H12',
  radar: 'M12 3a9 9 0 1 0 9 9M12 7.5A4.5 4.5 0 1 0 16.5 12M12 12l7-7',
  fingerprint:
    'M12 4.5a7.5 7.5 0 0 0-7.5 7.5v2M12 4.5a7.5 7.5 0 0 1 7.5 7.5v3.5M8 12a4 4 0 0 1 8 0v5M12 12v7.5',
  globe: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 0c-2.5 2.4-3.8 5.4-3.8 9s1.3 6.6 3.8 9c2.5-2.4 3.8-5.4 3.8-9s-1.3-6.6-3.8-9ZM3.4 9h17.2M3.4 15h17.2',
  wall: 'M3 6h18v12H3zM3 12h18M9 6v6m6-6v6M6 12v6m6-6v6m6-6v6',
  gauge: 'M4 18a8 8 0 1 1 16 0M12 14l4.5-4.5',
  family:
    'M8.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm7.5 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM3.5 19v-1.5a5 5 0 0 1 10 0V19m2.5 0v-1.5a4.5 4.5 0 0 0-1.2-3.1',
  check: 'M4.5 12.5 9.5 17.5 19.5 7',
  star: 'M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9-5.2-2.8-5.2 2.8 1-5.9L3.5 9.7l5.9-.8L12 3.5Z',
  phone:
    'M6.5 3.5h3l1.5 4-2 1.5a12 12 0 0 0 6 6l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 4.5 5.7 2 2 0 0 1 6.5 3.5Z',
  chevron: 'M6 9.5 12 15.5 18 9.5',
  menu: 'M4 7h16M4 12h16M4 17h16',
  close: 'M6 6l12 12M18 6 6 18',
  arrow: 'M5 12h13m0 0-5.5-5.5M18 12l-5.5 5.5',
  mail: 'M3.5 6h17v12h-17zM3.5 6.5 12 13l8.5-6.5',
  chat: 'M4 5.5h16v11H8.5L4 20.5V5.5Z',
  clock: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 4.5V12l3 2',
  cart: 'M3.5 4.5h2l2.2 10.5h9.6l2.2-7.5H6M9.5 19.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
  refresh: 'M20 12a8 8 0 1 1-2.4-5.7M20 4v4h-4',
  card: 'M3 6h18v12H3zM3 10h18M6.5 15h3',
};

export default function Icon({
  name,
  size = 24,
  className = '',
  fill = false,
  strokeWidth = 1.6,
  style,
}) {
  const d = paths[name];
  if (!d) return null;

  return (
    <svg
      className={className}
      style={style}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={fill ? 0 : strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={d} />
    </svg>
  );
}
